import React from "react";
import {TextButton} from "js/common/views/inputs/buttons";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";

const ScheduleUnsavedChangesDialog = ({onDiscard, onCancel}) => {
  const {theme} = React.useContext(CustomThemeContext);

  const handleDiscard = () => {
    onDiscard();
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <div style={{padding: "1.5rem 0 0.5rem 0", overflow: "hidden", textAlign: "center"}}>
      <svg width="58" height="58" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="#F59E0B" strokeWidth="2" fill="none" />
        <line x1="12" y1="8" x2="12" y2="12" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="16" r="1" fill="#F59E0B" />
      </svg>

      <p style={{marginTop: "0.5rem", fontSize: "20px", padding: "0 1rem"}}>
        You have unsaved changes
        <span style={{display: "block", fontSize: "14px", marginTop: 0, marginBottom: 10}}>
          Do you want to stay or leave and discard your changes?
        </span>
      </p>

      <div style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
        <TextButton
          key="schedule-unsaved-cancel"
          style={{
            float: "right",
            marginRight: "1rem",
            marginLeft: "0.5rem",
            backgroundColor: theme.palette.background.paper
          }}
          label={"Stay"}
          onClick={handleCancel}
        />
        <TextButton
          key="schedule-unsaved-discard"
          type="alert"
          label="Leave"
          style={{marginLeft: "0.5rem", color: "#fff", marginRight: "0.5rem"}}
          onClick={handleDiscard}
        />
      </div>
    </div>
  );
};

export default ScheduleUnsavedChangesDialog;
